import teaLatte from "../images/tea-latte.png";
import tea from "../images/tea.png";
import coldCoffee from "../images/coldCoffee.png";
import butterscotchMilkshake from "../images/butterscotchMilkshake.png";
import blueLagoon from "../images/blueLagoon.png";
import sandwich from "../images/sandwich.png";
import chinesePasta from "../images/chinesePasta.png";
import espresso from "../images/espresso.png";
import cappuccino from "../images/cappuccino.png";
import chocoEspresso from "../images/chocoEspresso.png";
import americano from "../images/americano.png";
import pastry from "../images/pastry.png";
import chocoPastry from "../images/chocoPastry.png";
import macaroons from "../images/macaroons.png";
import pancake from "../images/pancake.png";
import cookie from "../images/cookie.png";
import croissant from "../images/croissant.png";
import chocoCroissant from "../images/chocoCroissant.png";
const IndividualItemsMenu = [
  {
    category: "tea-latte",
    name: "Tea Latte",
    image: teaLatte,
    alt: "tea-latte",
  },
  {
    category: "tea",
    name: "Chai Tea",
    image: tea,
    alt: "tea",
  },
  {
    category: "cold-coffee",
    name: "Chilled Coffee",
    image: coldCoffee,
    alt: "cold-coffee",
  },
  {
    category: "espresso",
    name: "Espresso",
    image: espresso,
    alt: "espresso",
  },
  {
    category: "chocolate-espresso",
    name: "Chocolate Espresso",
    image: chocoEspresso,
    alt: "chocolate-espresso",
  },
  {
    category: "cappuccino",
    name: "Cappuccino",
    image: cappuccino,
    alt: "cappuccino",
  },
  {
    category: "americano",
    name: "Americano",
    image: americano,
    alt: "americano",
  },
  {
    category: "butterscotch-milkshake",
    name: "Butterscotch Milkshake",
    image: butterscotchMilkshake,
    alt: "butterscotch-milkshake",
  },
  {
    category: "blue-lagoon",
    name: "Blue Lagoon",
    image: blueLagoon,
    alt: "blue-lagoon",
  },
  {
    category: "strawberry-delight",
    name: "Strawberry Delight",
    image: pastry,
    alt: "strawberry-delight",
  },
  {
    category: "chocolate-pastry",
    name: "Chocolate Pastry",
    image: chocoPastry,
    alt: "chocolate-pastry",
  },
  {
    category: "macaroons",
    name: "Macaroons",
    image: macaroons,
    alt: "macaroons",
  },
  {
    category: "golden-honey-pancakes",
    name: "Golden Honey Pancake",
    image: pancake,
    alt: "golden-honey-pancakes",
  },
  {
    category: "chocochip-cookies",
    name: "Chocochip Cookies",
    image: cookie,
    alt: "chocochip-cookies",
  },
  {
    category: "butter-bliss",
    name: "Butter Bliss",
    image: croissant,
    alt: "butter-bliss",
  },
  {
    category: "chocolate-croissant",
    name: "Chocolate Croissant",
    image: chocoCroissant,
    alt: "chocolate-croissant",
  },
  {
    category: "grilled-cheese-sandwich",
    name: "Grilled Cheese Sandwich",
    image: sandwich,
    alt: "sandwich",
  },
  {
    category: "chinese-pasta",
    name: "Chinese Pasta",
    image: chinesePasta,
    alt: "chinese-pasta",
  },
];

export default IndividualItemsMenu;
